module.exports = "/virtual-football-league/img/amblems/left/logos/Liverpool.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/virtual-football-league/img/amblems/left/logos/Liverpool.png
// module id = 2107
// module chunks = 4